import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { buildInstanceCreatePayload } from './utils';

const FASTAPI_URL = process.env.REACT_APP_API_URL;
const NODE_API_URL = process.env.REACT_APP_NODE_API_URL; // Retained for other components; not used here after proxying

const getActiveBrand = () => {
    if (process.env.REACT_APP_BRAND) return process.env.REACT_APP_BRAND;
    const host = window.location.hostname;
    if (host === 'jcal.app' || host === 'www.jcal.app' || host.endsWith('.jcal.app')) return 'jcal';
    return 'happtrak';
};

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    //TODO: Remove fn below?
    const retryWithDelay = async (fn, retries = 3, delay = 1000) => {
        for (let i = 0; i < retries; i++) {
            try {
                return await fn(); // Try the function
            } catch (error) {
                if (i === retries - 1) throw error; // Throw the error if no retries left
                await new Promise((resolve) => setTimeout(resolve, delay)); // Wait before retrying
            }
        }
    };    

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const loginResponse = await axios.post(
                `${FASTAPI_URL}/api/login`,
                { email, password, app: getActiveBrand() },
                { withCredentials: true }
              );
              if (loginResponse.data.status === 'success') {
                localStorage.setItem('userToken', loginResponse.data.token || 'dummyToken');
                const userId = loginResponse.data.user_id;
    
                if (userId) {
                    //const statusResponse = await axios.get(`${NODE_API_URL}/api/connection-status/${userId}`);
                const has_wa_instance = loginResponse.data.has_wa_instance;
                const connection_status = loginResponse.data.connection_status;
                    
                    const emailSafe = email.replace(/@/g, '-at-').replace(/\./g, '-dot-');
                    const instanceId = `${emailSafe}@${uuidv4()}`;

                    if (connection_status === true) {
                        navigate(`/manage-connection/${userId}`, { state: { userId } });
                    } 
                    else if (!(has_wa_instance)) {
                        const data = buildInstanceCreatePayload(instanceId);
                        
                          axios
                            // Use FastAPI proxy to ensure correct environment (staging vs prod)
                            .post(`${FASTAPI_URL}/api/instance/create`, data, {
                              headers: { 'Content-Type': 'application/json' }
                            })
                          .then(response => {
                            //console.log(response.data);
                            if (response.data.qrcode) {
                                navigate(`/qr-code/${userId}`, { state: { qrCode: response.data.qrcode.base64,
                                    instanceId: instanceId }})
                            } else {
                                setError('Failed to retrieve QR code. Please try again.');
                            }
                          })
                          .catch((err) => {
                            console.error('Error during WhatsApp connection or QR code retrieval:', err);
                            setError('An error occurred. Please try again.');
                        });
                    }
                } else {
                    setError('Login succeeded but no user ID returned.');
                }
            } else {
                setError(loginResponse.data.message || 'Login failed');
            }
        } catch (err) {
            console.error(err);
            setError('Error logging in. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <div>
            <h1>Login</h1>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {loading && <p>Loading...</p>}
            <form onSubmit={handleLogin}>
                <label>
                    Email:
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </label>
                <br />
                <label>
                    Password:
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </label>
                <br />
                <button type="submit" disabled={loading}>Login</button>
            </form>
            <p>
                Don't have an account? <button onClick={() => navigate('/register')}>Register</button>
            </p>
        </div>
    );
};

export default Login;
